import { render, staticRenderFns } from "./Assessment.vue?vue&type=template&id=994e4178&scoped=true"
import script from "./Assessment.vue?vue&type=script&lang=js"
export * from "./Assessment.vue?vue&type=script&lang=js"
import style0 from "./Assessment.vue?vue&type=style&index=0&id=994e4178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994e4178",
  null
  
)

export default component.exports